import type { Data } from '@repo/strapi'
import AppLink from '@/components/elementary/AppLink'
import { NavbarMenuLink } from '@/components/elementary/navbar/NavbarMenuLink'
import { ArrowRight } from '@/components/icons/ArrowRight'
import { Paragraph } from '@/components/typography/Paragraph'
import { cn } from '@/lib/styles'
import { NAVBAR_TEST_IDS } from '@/lib/test-ids'
import styles from './NavbarMenuLink.module.css'

interface CategoryColumnProps {
	readonly column: Data.Component<'layout-utilities.column-section'>
	readonly testId?: string
	readonly className?: string
	onLinkClick?: () => void
}

export function CategoryColumn({ column, testId, className, onLinkClick }: CategoryColumnProps) {
	const hasPinkIcon = column.links?.some((link) => !!link.IsIconPink)

	return (
		<div className={cn('grid gap-4 h-fit min-w-42', className)} data-test-id={testId}>
			{column?.title && (
				<Paragraph fontSize="headingSubtitle" textColor="gray">
					{column?.title}
				</Paragraph>
			)}

			<div className={cn('grid auto-rows-fr', [hasPinkIcon ? 'gap-5' : 'gap-4'])}>
				{column?.links?.map((link) => (
					<NavbarMenuLink
						key={link?.id}
						link={link}
						testId={NAVBAR_TEST_IDS.CATEGORY_COLUMN_LINK}
						onClick={onLinkClick}
					/>
				))}
			</div>

			{column?.seeMoreLink?.href && column?.seeMoreLink?.title ? (
				<AppLink
					href={column?.seeMoreLink?.href}
					openExternalInNewTab={column?.seeMoreLink?.newTab ?? false}
					variant="primaryLink"
					underline
					className="w-fit"
					iconRight={<ArrowRight className="size-3 lg:size-4 text-brand-black" />}
					data-test-id={NAVBAR_TEST_IDS.CATEGORY_COLUMN_SEE_MORE}
					onClick={onLinkClick}
				>
					<Paragraph className={styles['nav-content-menu-arrow-link']}>
						{column?.seeMoreLink?.title}
					</Paragraph>
				</AppLink>
			) : null}
		</div>
	)
}
